var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniExercise03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D6895E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_13560",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#4A5294"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_13560)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.301,
    y: 41.75,
    width: 94.838,
    height: 42.1502,
    rx: 4,
    fill: "#C3CCFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.01,
    y: 41.75,
    width: 47.419,
    height: 168.601,
    fill: "#C3CCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.01 83.9219H184.429V126.356L137.01 94.727V83.9219Z",
    fill: "#9AA5E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.301,
    y: 168.201,
    width: 94.838,
    height: 42.1502,
    rx: 4,
    fill: "#C3CCFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.434,
    y: 93.6426,
    width: 69.0261,
    height: 30.6782,
    rx: 4,
    transform: "rotate(-18 181.434 93.6426)",
    fill: "#4841A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.847,
    y: 88.3145,
    width: 34.513,
    height: 122.713,
    transform: "rotate(-18 197.847 88.3145)",
    fill: "#4841A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.875,
    y: 181.166,
    width: 69.0261,
    height: 30.6782,
    rx: 4,
    transform: "rotate(-18 209.875 181.166)",
    fill: "#4841A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.293 117.395L240.117 106.729L249.697 136.213L209.759 124.984L207.293 117.395Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34 242.053V222.256H190.105C194.604 222.256 197.188 225.031 197.188 228.928C197.188 232.879 194.562 235.6 189.996 235.6H186.441V242.053H182.34ZM186.441 232.291H189.34C191.773 232.291 192.963 230.924 192.949 228.928C192.963 226.959 191.773 225.633 189.34 225.619H186.441V232.291ZM201.152 242.299C199.867 242.299 198.828 241.273 198.855 240.002C198.828 238.744 199.867 237.719 201.152 237.732C202.369 237.719 203.422 238.744 203.422 240.002C203.422 241.273 202.369 242.299 201.152 242.299ZM206.758 242.053V222.256H214.523C219.021 222.256 221.605 225.031 221.605 228.928C221.605 232.879 218.98 235.6 214.414 235.6H210.859V242.053H206.758ZM210.859 232.291H213.758C216.191 232.291 217.381 230.924 217.367 228.928C217.381 226.959 216.191 225.633 213.758 225.619H210.859V232.291ZM228.168 222.256V242.053H224.121V222.256H228.168ZM238.039 242.354C233.486 242.34 230.697 239.4 230.711 234.697C230.697 230.117 233.527 227.014 237.875 227.014C241.771 227.014 244.848 229.475 244.848 234.533V235.682H234.703C234.703 237.924 236.029 239.305 238.121 239.318C239.502 239.305 240.486 238.703 240.883 237.814H244.738C244.164 240.562 241.703 242.34 238.039 242.354ZM234.703 233.139H241.02C241.006 231.334 239.762 230.035 237.957 230.049C236.098 230.035 234.785 231.43 234.703 233.139Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniExercise03);
export default __webpack_public_path__ + "static/media/mini_exercise_03.51e071c991eb4829a10c45136e56e5f7.svg";
export { ForwardRef as ReactComponent };